var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11146_5196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7689 9.4395V22.5677C30.7689 27.0992 27.0953 30.7728 22.5638 30.7728H9.4356C4.90404 30.7728 1.23047 27.0992 1.23047 22.5677V9.4395C1.23047 4.90794 4.90404 1.23438 9.4356 1.23438H22.5638C27.0953 1.23438 30.7689 4.90794 30.7689 9.4395Z",
    stroke: "#F4F6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.718 16.0024C9.99907 16.0024 7.79492 18.2065 7.79492 20.9255C7.79492 23.6445 9.99907 25.8486 12.718 25.8486C15.437 25.8486 17.6411 23.6445 17.6411 20.9255V6.15625C18.188 7.79728 20.2667 11.0793 24.2052 11.0793",
    stroke: "#F4F6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11146_5196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.c06436c72373a4c97e56d2517cb471b5.svg";
export { ForwardRef as ReactComponent };